var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14173_1094769)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.38889 1.5625C0.621826 1.5625 0 2.17462 0 2.92971C0 3.68479 0.621826 4.29691 1.38889 4.29691H3.02805L5.58252 16.8699C5.71236 17.509 6.28238 17.969 6.94444 17.969H20.8333C21.4534 17.969 21.9984 17.5643 22.1688 16.9774L24.9465 7.40692C25.0663 6.99441 24.9824 6.5505 24.7199 6.208C24.4575 5.86549 24.0469 5.66412 23.6111 5.66412H6.13861L5.52858 2.66157C5.39874 2.02251 4.82872 1.5625 4.16667 1.5625H1.38889ZM8.08306 15.2346L6.69417 8.39853H21.7698L19.7857 15.2346H8.08306ZM7.63997 23.4376C8.79056 23.4376 9.7233 22.5194 9.7233 21.3867C9.7233 20.2541 8.79056 19.3359 7.63997 19.3359C6.48938 19.3359 5.55664 20.2541 5.55664 21.3867C5.55664 22.5194 6.48938 23.4376 7.63997 23.4376ZM20.14 23.4376C21.2906 23.4376 22.2233 22.5194 22.2233 21.3867C22.2233 20.2541 21.2906 19.3359 20.14 19.3359C18.9894 19.3359 18.0566 20.2541 18.0566 21.3867C18.0566 22.5194 18.9894 23.4376 20.14 23.4376Z",
    fill: "grey"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14173_1094769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.4dfcdc1bc551461fce82a0c60461c720.svg";
export { ForwardRef as ReactComponent };